import React, {useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import {Button, Divider, Grid} from "@mui/material";
import AlertBar from "../../../components/AlertBar";
import {BASE_URL} from "../../../constants";
import {reportErrors} from "../../../helpers";
import {FileUploadOutlined} from "@mui/icons-material";
import Form from "../../../components/Form";

export default function BasicSettings(props) {
    const form = useRef();
    const alert = useRef();
    const [canUpload, setCanUpload] = useState(true);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        let data = new FormData();
        data.append("banner", file);
        if (form.current.validate()) {
            setCanUpload(false);
            window.axios
                .post(`${BASE_URL}api/upload-banner`, data)
                .then((response) => {
                    alert.current.showSuccess("Uploaded successfully.");
                    setTimeout(() => {
                        setCanUpload(true);
                    }, 2000);
                })
                .catch((error) => {
                    reportErrors(alert.current, error);
                    setCanUpload(true);
                });
        }
    };

    return (<>
        <Box>
            <AlertBar ref={alert}/>
            <Form ref={form}>
                <Grid container spacing={1}>
                    <Grid item xs={3}>
                        <Button
                            disabled={!canUpload}
                            startIcon={<FileUploadOutlined/>}
                            variant="contained"
                            component="label"
                            fullWidth
                            size="medium"
                            sx={{mt: 1}}
                        >
                            Upload Company Logo
                            <input
                                type="file"
                                hidden
                                onChange={handleFileUpload}
                                encType="multipart/form-data"
                            />
                        </Button>
                    </Grid>
                    <Grid item xs={12}><Divider/></Grid>
                </Grid>
            </Form>
        </Box>
    </>);
}